<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">车辆派遣申请</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <el-form-item label="车辆类型">
            <el-radio-group size="small" v-model="carType" class="type-radio-type">
              <el-radio-button label="1">生产经营保障用车</el-radio-button>
              <el-radio-button label="2">租用车辆</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <car-dispatch ref="create" :carType="carType" :userData="userData" :formByFather="form"></car-dispatch>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
              <div class="tip" style="line-height:26px">
                <p>1. 出县车辆须经部门负责人审核;<br />
                  2. 跨地区使用车辆须经分管副总审批;<br />
                  3. 跨公司使用/出省车辆须经集团公司分管副总审批。</p>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitCar()" class="form-btn" type="success">确认提交车辆派遣申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import CarDispatch from '@/page/form/car/dispatch'
  export default {
    components: {
      ApprovalItem,
      CarDispatch,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          depId: "",

          carId: "",
          applyTime: "",
          setOutTime: "",
          address: "",
          reason: "",

          applyType: "",
          json: true,
        },
        // useApplyType: "",
        carType: "",
        approvalUsersData: '',
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      this.carType = "1"
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/car/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.carId = this.form.car.id
          this.form.depId = this.form.department.id
          this.form.applyId = this.form.flow.applyId

          this.form.json = true

          switch (this.form.type) {
            case 84:
              this.carType = '1'
              break;
            case 85:
              this.carType = '2'
              break;
          }
          this.form.applyType = this.form.type

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, this.applyInfo.type)
          this.formLoading = false
        })
      },
      // 提交使用车辆申请单
      SubmitCar() {
        this.form = this.$refs.create.getFromData()

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        if (!this.form.carId) {
          this.$message.error('请选择车辆，如无对应车辆信息，请联系相关同事添加')
          return
        }

        this.formLoading = true
        let _url = !this.form.applyId ? '/car/apply' : '/car/apply/edit?applyId=' + this.form.applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交车辆派遣申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改车辆派遣申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Car/DispatchList')
        }, (res) => {
          this.formLoading = false
        })
      },
      // 识别审批type
      calcApplyType() {
        switch (this.carType) {
          case '1':
            this.form.applyType = '84'
            break;
          case '2':
            this.form.applyType = '85'
            break;
        }
        this.approvalUsersData = this.approvalUsers['c' + this.form.applyType]
        this.setSelectArr(this.applyInfo, this.form.applyType)
      },
    },
    watch: {
      'carType'() {
        this.calcApplyType()
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/car/dispatchApply.vue